import { BaseModel } from './BaseModel';

/**
 * One row of a migration's per-entity audit trail (what happened to each
 * source record during apply).
 */
export class MigrationEntity extends BaseModel {
    public id = '';
    public entityType = '';
    public sourceRef = '';
    public targetId: string | null = null;
    public outcome = '';
    public message: string | null = null;
}
